import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import SuperadminLayout from "@/components/superadmin/layout";
import useTranslations from "@/hooks/use-translations";
import { SuperadminDashboardPageProps } from "@/types";
import { ReactNode } from "react";

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <Card>
      <CardHeader>
        <CardDescription>{label}</CardDescription>
        <CardTitle className="text-3xl font-semibold tabular-nums">
          {value.toLocaleString()}
        </CardTitle>
      </CardHeader>
    </Card>
  );
}

function DashboardPage({ counts }: SuperadminDashboardPageProps) {
  const { t } = useTranslations("superadmin.dashboard");

  return (
    <div className="flex flex-col gap-6">
      <h2 className="font-semibold text-2xl">{t("title")}</h2>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <StatCard label={t("stats.users")} value={counts.users} />
        <StatCard label={t("stats.stores")} value={counts.stores} />
        <StatCard
          label={t("stats.active_subscriptions")}
          value={counts.active_subscriptions}
        />
        <StatCard label={t("stats.products")} value={counts.products} />
        <StatCard label={t("stats.collections")} value={counts.collections} />
      </div>
    </div>
  );
}

DashboardPage.layout = (page: ReactNode) => (
  <SuperadminLayout children={page} />
);

export default DashboardPage;
